import React, { useCallback, useMemo } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { selectApiUrls } from '../../redux/slices/apiUrlSlice';
import { useGetShippingScheduleQuery, useGetDataQuery, refreshBackgroundQuery } from '../../redux/api/portalApi';
import { hasShippingPackDue } from '../../utils/shippingEligibility';
import useShippingLiveUpdates from './useShippingLiveUpdates';
import AssemblyScheduleChangeLog from '../AssemblyPage/AssemblyScheduleChangeLog';
import { normalizeShippingSchedule, shippingProjectId } from './shippingConfig';

export default function ShippingChangeLog() {
  const dispatch = useDispatch();
  const urls = useSelector(selectApiUrls);
  const schedule = useGetShippingScheduleQuery({ url: urls.fullSchedule }, { skip: !urls.fullSchedule, refetchOnMountOrArgChange: true });
  // Share the exact query key with the rendered log so its filters survive updates.
  const log = useGetDataQuery({ url: urls.shippingChangeLog }, { skip: !urls.shippingChangeLog });
  const live = useShippingLiveUpdates({ enabled: true, scope: urls.shipping,
    blocked: schedule.isFetching || log.isFetching,
    refresh: async (options) => {
      if (!urls.fullSchedule || !urls.shippingChangeLog) return false;
      const results = await Promise.all([
        dispatch(refreshBackgroundQuery('getShippingSchedule', { url: urls.fullSchedule }, options)),
        dispatch(refreshBackgroundQuery('getData', { url: urls.shippingChangeLog }, options)),
      ]);
      return results.every(Boolean);
    } });
  const eligibleIds = useMemo(() => new Set(normalizeShippingSchedule(schedule.data).filter(hasShippingPackDue).map((job) => String(job.ProjectId))), [schedule.data]);
  const filterEntry = useCallback((entry) => eligibleIds.has(String(shippingProjectId(entry))), [eligibleIds]);
  if (!urls.fullSchedule || schedule.error) return <Alert variant="danger">Unable to load Pack Due dates for the Shipping Change Log. {urls.fullSchedule && <Button onClick={() => schedule.refetch()}>Retry</Button>}</Alert>;
  if (schedule.isLoading) return <p role="status">Loading shipping projects…</p>;
  return <>{live.warning && <Alert variant="warning" dismissible onClose={live.dismissWarning}>{live.warning}</Alert>}<AssemblyScheduleChangeLog apiKey="shippingChangeLog" title="Shipping Change Log" description="Audit history for shipping projects with a Pack Due date." filterEntry={filterEntry} onRefresh={schedule.refetch} /></>;
}
